import React from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../../redux/slices/auth.slice";

import StudentEditProfile from "../forms/StudentEditProfile";
import ProfileBanner from "./ProfileBanner";
import { serverUrl } from "../../nestserver";
import SocialButton from "../widgets/SocialButton";

function StudentMainProfile() {
  const user = useSelector(selectUser);

  return (
    <ProfileBanner
      userId={user?._id}
      roleData={user?.student}
      patchUrl={serverUrl + "/students/" + user?.student?._id}
      EditFormComponent={StudentEditProfile}
      extraContent={
        <>
          <div className="text-sm font-bold">{user?.student?.unique_id}</div>
          <div className="text-sm font-bold">{user?.student?.class?.name}</div>
          <div className="flex items-center space-x-4">
            {user?.student?.social_links?.map((item, index) => (
              <SocialButton key={index} data={item} />
            ))}
          </div>
        </>
      }
    />
  );
}

export default StudentMainProfile;
